<template>
  <div class="filter-links">
    <span v-if="productTypesAttr.links.length > 0" class="filter-links__title" v-html="productTypesAttr.title"></span>
    <ul class="filter-links__list" :class="[this.showMore ? 'open' : '']">
      <li :class="[activeTypes.indexOf(' ' + link.val + ' ') > -1 ? 'filter-links__list-item filter-links__list-item--active': 'filter-links__list-item']"
          v-for="(link, index) in productTypesAttr.links" :key="index">
        <a :href="link.url" @click="triggerFilter(link.val, 'type',$event)" data-name="type" :data-remove="[activeTypes.indexOf(' ' + link.val + ' ') > -1]" :data-val="link.val" v-html="link.title"></a>
      </li>
    </ul>
    <a class="filter-size-toggle" href="javascript:;" v-if="productTypesAttr.links.length > 6" @click="toggleShowMore">
      Show {{ this.showMore ? 'Less' : 'More' }}
      <SvgIcon class="filter-size-toggle-icon" :iconName="this.showMore ? 'ico-arrow-up': 'ico-arrow-down'"/>
    </a>
  </div>
</template>


<script>
import {EventBus} from '@/vue/store';
import Global from '../../../js/_site/global';
import SvgIcon from '../base/SvgIcon/SvgIcon.vue';

export default {
  props: ['productTypesAttr'],
  methods: {
    triggerFilter(val, name, event) {
      this.scrollToTop();
      if (event.target.parentElement.classList.contains('filter-links__list-item--active')) {
        EventBus.$emit('trigger-remove-pill', val, name, event);
      } else {
        this.$emit('filtersLoad', event);
        this.activeFilters = Global.readCookie('activeFilters');
        EventBus.$emit('active-filters', this.activeFilters);
        EventBus.$emit('active-filters-after-remove-type', event.target.getAttribute('data-name'));
        const setPageOne = location.href.replace('/' + this.sapData.pagination.currentPage + '/', '/1/');
        this.sapData.pagination.currentPage = 1;
        window.history.replaceState({}, '', setPageOne);
        EventBus.$emit('get-count', this.sapData.productsCount);
      }
      EventBus.$emit('active-filters-after-remove-type', name);
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
    scrollToTop() {
      const element = document.querySelector('.js-product-listing');
      const elementTop = element.offsetTop;
      const scrollPosition = elementTop - 120;

      window.scroll({
        top: scrollPosition,
        left: 0,
        behavior: 'smooth'
      });
    }
  },
  components: {
    SvgIcon
  },
  data() {
    return {
      // eslint-disable-next-line no-undef
      sapCategory: sapCategory,
      activeFilters: Global.readCookie('activeFilters'),
      activeTypes: Global.checkActive('type'),
      // eslint-disable-next-line no-undef
      sapData: sapData,
      showMore: false,
      remove: false,
    };
  },
  created() {
    EventBus.$on('active-filters-after-remove-type', filterName => {
      this.activeTypes = Global.checkActive(filterName);
    });
  }
};
</script>

<style lang="scss" scoped>
.filter-links {
}

.filter-links__title {
  font-size: 12px;
  font-family: $font-second;
  color: $grey;
  text-transform: uppercase;
  letter-spacing: 1.3px;
  margin-bottom: 14px;
  display: block;

  @include mq($md) {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
  }
}

.filter-links__list {
  max-height: 150px;
  height: auto;
  overflow: hidden;

  &.open {
    max-height: 1500px;
  }
}

.filter-size-toggle {
  font-size: 12px;
  font-family: $font-second;
  color: $grey;
  font-weight: 400;
  position: relative;
}

.filter-size-toggle-icon {
  height: 12px;
  font-size: 12px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -15px;
}

.filter-links__list-item {
  &:not(:last-child) {
    margin-bottom: 1px;
  }

  a {
    font-family: $font-second;
    color: #160b00;
    font-size: 14px;
    cursor: pointer;
    transition: $dur $ease;
    position: relative;
    font-weight: 400;
    text-transform: capitalize;

    &:hover {
      color: $grey-mid;
      transition: $dur $ease;
      font-weight: 600;
    }

    &::before {
      content: '';
      height: 2px;
      width: 0;
      opacity: 0;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      background-color: $dark-blue;
      transition: $dur $ease;
    }
  }
}

// Active state for link
.filter-links__list-item--active {
  a {
    padding-left: 26px;
    transition: $dur $ease;
    font-weight: 600;
    color: $dark-blue;

    &::before {
      width: 16px;
      transition: $dur $ease;
      opacity: 1;
    }
  }
}


</style>
